import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Grupo } from '../../common/grupo';
import { HeaderService } from './header.service';
import { IDBResponse } from '../../common/responses';

@Injectable()
export class GruposService {
    
    constructor(private $http: Http, private $headers: HeaderService){}
    
    getGrupos(): Observable<Grupo[]> {
        return this.$http.get(this.$headers.getApi() + '/grupos', { headers: this.$headers.getHeaders() })
            .map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
    
    /**
     * Funciones de edicion, creación y eliminacion de grupos
     */
    updateGrupo(data: { grupo: Grupo, update: boolean }): Observable<IDBResponse> {
        let http$: Observable<Response>;
        if (data.update === undefined)
            http$ = this.$http.delete(this.$headers.getApi() + '/grupo/' + data.grupo.idgrupo, { headers: this.$headers.getHeaders() })
        else if (data.update)
            http$ = this.$http.post(this.$headers.getApi() + '/grupo', data.grupo, { headers: this.$headers.getHeaders() })
        else
            http$ = this.$http.put(this.$headers.getApi() + '/grupo', data.grupo, { headers: this.$headers.getHeaders() })
        
        return http$.map(res => res.json())
            .catch((err: Response) => Observable.throw(err.json()));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/_services/grupo.service.ts